import React, { Component } from 'react';
import { TextField, TextFieldIcon, TextFieldHelperText } from 'rmwc/TextField';
import { FormField } from 'rmwc/FormField';
import {Button} from 'rmwc/Button';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux'
import { Card } from 'rmwc/Card';
import PlacesAutoComplete from 'react-places-autocomplete'

import StatusMessage from '../util/StatusMessage'

class TPORegistrationUpdate extends Component{

	constructor(props) {
	    super(props)
	    this.state = {
	      errorMsg: '',
	      loading: false,
        updateMessage: '',
	      data:{
	      	'certification_participation_id': '',
	      	'testcenters': [],
	        'testcenterId': '',
	        'testCenterName': '',
	        'testCenterCountryId': '',
	        'testTrackPrimaryList': [],
	        'testTrackPrimaryId': '',
	        'testTrackPrimaryName':'',
	        'testTrackOptionFirstList': [],
	        'testTrackOptionFirstId': '',
	        'testTrackOptionFirstName':'',
	        'testTrackOptionSecondList': [],
	        'testTrackOptionSecondId': '',
	        'testTrackOptionSecondName':'',
	        'countryFee': '',
	        'testLocations': [],
        	'testLocationOne': '',
        	'testLocationTwo': '',
        	"noOfSelectedTrack": 0,
        	'payment_modes': [],
        	'paymentModeId' :'',
        	'testLocations': [],
        	'testLocationOne': '',
        	"testLocationTwo": '',
          "firstName": '',
          "lastName": '',
          "email": '',
          'teachingAssociations': [],
          'teachingAssociationId': '',
          'teachingAssociationName': '',
          'workingOrganization': '',
          'referralCode': '',

	      },

	      timeSlots:{
        'primarySlots': [],
        'optionFirstSlots': [],
        'optionSecondSlots': [],
        'primarySlotId':'',
        'optionFirstSlotId': '',
        'optionSecondSlotId': '',
        'primaryStart':'',
        'primaryStartM':'',
        'primaryEnd':'',
        'primaryEndM':'',
        'optionFirstStart': '',
        'optionFirstStartM': '',
        'optionFirstEnd':'',
        'optionFirstEndM':'',
        'optionSecondStart': '',
        'optionSecondStartdM': '',
        'optionSecondEnd': '',
        'optionSecondEndM': '',
        'testLocationPrefOne': '',
        'testLocationPrefTwo': '',
        
      },

      trackFee:{
        PrimaryFee:0,
        optionFirstFee:0,
        optionSecondFee:0,
        feeToBePaid:0,
      },

      saveState:{
        saveDisabled: false
      },

      formErrors:{
        'testCenterError': '',
        'testTrackPrimaryIdError':'',
        'primarySlotIdError':'',
        'optionFirstSlotIdError':'',
        'optionSecondSlotIdError':'',
        'optionThirdWithoutSecondError': '',
        'paymentModeError':'',
        'firstNameError': '',
        'lastNameError': '',
        'emailError': '',
        'teachingAssociationIdError':'',
        'workingOrganizationError':'',
        'discountCodeError':''
      },

	    };

	}


	componentDidMount(){
		
		let data = Object.assign({}, this.state.data)
		let timeSlots = Object.assign({}, this.state.timeSlots)
		let trackFee = Object.assign({}, this.state.trackFee)
		let cert_part_id = this.props.match.params.cert_part_id
		let fetchTpoUrl = `tpo_reg_details_update/${this.props.match.params.cert_part_id}` 

		api.getResponse(this.props.user.accessToken, fetchTpoUrl)
      .then((result) =>{
      		data.certification_participation_id = cert_part_id
          data.testcenterId = result.data.test_center_id
          data.testCenterCountryId = result.data.test_center_country_id.toString()
          data.testLocationOne = result.data.test_location_pref_one
          data.testLocationTwo = result.data.test_location_pref_two
          
          if(result.data.payment_amount !== undefined){
            trackFee.feeToBePaid = result.data.payment_amount  
          }
          
          if(result.data.payment_mode_id !== undefined){
            data.paymentModeId = result.data.payment_mode_id
          }

          if(result.data.payment_discount_code !== undefined){
            if(result.data.payment_discount_code !== null){
              data.referralCode = result.data.payment_discount_code
            }
          }
          

          // Personal Info and email
          if(result.data.first_name !== undefined){
            data.firstName = result.data.first_name
          }

          if(result.data.last_name !== undefined){
            data.lastName = result.data.last_name
          }

          data.email = result.data.email

          // teaching association and working organization
          if(result.data.teaching_association_id !== null){
            data.teachingAssociationId = result.data.teaching_association_id

          }
          if(result.data.working_organization !== null){
            data.workingOrganization = result.data.working_organization  
          }
          
          if(result.data.test_tracks[0] !== undefined){
          	data.testTrackPrimaryId = result.data.test_tracks[0]
          	timeSlots.primarySlotId = result.data.time_slots[0]
          	timeSlots.primarySlots = result.data.all_slots_for_track[0]
          	trackFee.PrimaryFee = result.data.test_track_fees[0]
          	result.data.all_slots_for_track[0].map(function(level){
          		if(level.id ===  result.data.time_slots[0]){
          			timeSlots.primaryStart = level.start_time
      					timeSlots.primaryStartM = level.start_time_meridiem
      					timeSlots.primaryEnd = level.end_time
      					timeSlots.primaryEndM = level.end_time_meridiem
          		}
          	})
          	
          }
          if(result.data.test_tracks[1] !== undefined){
          	data.testTrackOptionFirstId = result.data.test_tracks[1]
          	timeSlots.optionFirstSlotId = result.data.time_slots[1]
          	timeSlots.optionFirstSlots = result.data.all_slots_for_track[1]
          	trackFee.optionFirstFee = result.data.test_track_fees[1]
          	result.data.all_slots_for_track[1].map(function(level){
          		if(level.id ===  result.data.time_slots[1]){
          			timeSlots.optionFirstStart = level.start_time
      					timeSlots.optionFirstStartM = level.start_time_meridiem
      					timeSlots.optionFirstEnd = level.end_time
      					timeSlots.optionFirstEndM = level.end_time_meridiem
          		}
          	})
          }
          if(result.data.test_tracks[2] !== undefined){
          	data.testTrackOptionSecondId = result.data.test_tracks[2]
          	timeSlots.optionSecondSlotId = result.data.time_slots[2]
          	timeSlots.optionSecondSlots = result.data.all_slots_for_track[2]
          	trackFee.optionSecondFee = result.data.test_track_fees[2]
          	result.data.all_slots_for_track[2].map(function(level){
          		if(level.id ===  result.data.time_slots[2]){
          			timeSlots.optionSecondStart = level.start_time
      					timeSlots.optionSecondStartM = level.start_time_meridiem
      					timeSlots.optionSecondEnd = level.end_time
      					timeSlots.optionSecondEndM = level.end_time_meridiem
          		}
          	})
          }
          return api.getTestCenters(this.props.user.accessToken)
      }) .then((result) =>{
          data.testcenters = result
       		return api.getTPOTestTracks(this.props.user.accessToken, data.testCenterCountryId)
      }).then((testTrackPrimaryList) => {
      	  data.testTrackPrimaryList = testTrackPrimaryList
      	  data.testTrackOptionFirstList = testTrackPrimaryList
      	  data.testTrackOptionSecondList = testTrackPrimaryList
      		//this.setState({data: data, timeSlots: timeSlots})
      		return api.getTPOCountryFee(this.props.user.accessToken, data.testCenterCountryId)
      }).then((result) => {
      	  data.countryFee = result
      		return api.getPaymentModes(this.props.user.accessToken)
      }).then((result) =>{
  			  
          data.payment_modes = result
          return api.getTPOLocation(this.props.user.accessToken, data.testcenterId)
      }).then((result) =>{
          data.testLocations = result
          return api.getTeachingAssociations('')
        }).then((result) =>{
          data.teachingAssociations = result
          this.setState({data: data, timeSlots: timeSlots, trackFee: trackFee, loading:true})              
        })

	}

	 handleTimeSlotChange =(event) => {
    let timeSlots = Object.assign({}, this.state.timeSlots)
    let optionElement = event.target.childNodes[event.target.selectedIndex]
    let optionSequence = optionElement.getAttribute('option-sequence')
    let start = optionElement.getAttribute('option-start')
    let end = optionElement.getAttribute('option-end')
    let startM = optionElement.getAttribute('option-startm')
    let endM = optionElement.getAttribute('option-endm')
    
    let timeSlotId = event.target.value

    if(optionSequence === '1'){
      timeSlots.primarySlotId = timeSlotId
      timeSlots.primaryStart = start
      timeSlots.primaryStartM = startM
      timeSlots.primaryEnd = end
      timeSlots.primaryEndM = endM
    }
    else if (optionSequence === '2'){
      timeSlots.optionFirstSlotId = timeSlotId
      timeSlots.optionFirstStart = start
      timeSlots.optionFirstStartM = startM
      timeSlots.optionFirstEnd = end
      timeSlots.optionFirstEndM = endM
    }
    else if (optionSequence === '3'){
      timeSlots.optionSecondSlotId = timeSlotId
      timeSlots.optionSecondStart = start
      timeSlots.optionSecondStartdM = startM
      timeSlots.optionSecondEnd = end
      timeSlots.optionSecondEndM = endM
    }
    
    this.setState({timeSlots: timeSlots})
    
  }


	checkTimeOverlap = (optionSequence, start, StartM, end, endM) => {
    let overlap = false

    if(optionSequence === 1 || optionSequence === 2){
      //console.log('inside option seq 1  2')
      //Check with sequence 3
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.optionSecondStart,
            this.state.timeSlots.optionSecondStartdM, this.state.timeSlots.optionSecondEnd,
            this.state.timeSlots.optionSecondEndM))
        overlap = true
    }

    if(optionSequence === 1 || optionSequence === 3){
      //console.log('inside option seq 1  3')
      //Check with sequence 2
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.optionFirstStart,
            this.state.timeSlots.optionFirstStartM, this.state.timeSlots.optionFirstEnd,
            this.state.timeSlots.optionFirstEndM))
        overlap = true
    }

    if(optionSequence === 3 || optionSequence === 2){
      //console.log('inside option seq 3  2')
      //Check with sequence 1
      if(this.isTimeSlotOverlap(start, end, StartM, endM, this.state.timeSlots.primaryStart,
            this.state.timeSlots.primaryStartM, this.state.timeSlots.primaryEnd,
            this.state.timeSlots.primaryEndM))
        overlap = true
    }
    return overlap
  }

  isTimeSlotOverlap = (start, end, startM, endM, existingStart, existingStartM, existingEnd, existingEndM) => {
    let overlap = false
    
    start = this.transformPMHours(start, startM)
    end = this.transformPMHours(end, endM)
    existingStart = this.transformPMHours(existingStart, existingStartM)
    existingEnd = this.transformPMHours(existingEnd, existingEndM)

    if((start >= existingStart && start <= existingEnd)
        || (end >= existingStart && end <= existingEnd)){
      overlap = true
      //console.log('inside overlap true setting')
    }
    return overlap
  }

  transformPMHours = (hourVal, hourMeridien) => {
    hourVal = Number(hourVal)
    if(hourVal < 12 &&  hourMeridien === 'PM')
      hourVal = hourVal +12
    return hourVal
  }

  getTimeSlotForTrack(testTrackId, trackType, optionSequence){
    let timeSlots = Object.assign({}, this.state.timeSlots)
    api.getTPOTimeSlot(this.props.user.accessToken,testTrackId, trackType)
          .then((result) => {
                       
            if (Number(optionSequence) === 1){
              timeSlots.primarySlots = result
              timeSlots.primarySlotId =''
              timeSlots.primaryStart = ''
      				timeSlots.primaryStartM = ''
      				timeSlots.primaryEnd = ''
      				timeSlots.primaryEndM = ''
            }
            else if (Number(optionSequence) === 2) {
              timeSlots.optionFirstSlots = result
              timeSlots.optionFirstSlotId =''
              timeSlots.optionFirstStart = ''
      				timeSlots.optionFirstStartM = ''
      				timeSlots.optionFirstEnd = ''
      				timeSlots.optionFirstEndM = ''
            }
            else {  
              timeSlots.optionSecondSlots = result
              timeSlots.optionSecondSlotId =''
              timeSlots.optionSecondStart = ''
      				timeSlots.optionSecondStartdM = ''
      				timeSlots.optionSecondEnd = ''
      				timeSlots.optionSecondEndM = ''
            }
            this.setState({timeSlots: timeSlots})

            //console.log(this.state.timeSlots)
    })
  }

  computeFeeToBePaid(testTrackId, optionSequence){
    let trackFee = Object.assign({}, this.state.trackFee)
    api.getTPOTrackFee('',testTrackId)
      .then((result) => {
          if (Number(optionSequence) === 1){
            trackFee.PrimaryFee = result.data
          }
          else if (Number(optionSequence) === 2) {
            trackFee.optionFirstFee = result.data 
          }
          else if (Number(optionSequence) === 3){  
            trackFee.optionSecondFee = result.data
          }
          trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
          this.setState({trackFee: trackFee})
      
    }).catch((err) => {
        this.setState({ errorMsg: err.stack })
    })
  }

  handleTestTrackPrimaryChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackPrimaryId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackPrimaryName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackPrimaryId, 1, 1)
      this.computeFeeToBePaid(data.testTrackPrimaryId, 1)
      if(this.state.data.testTrackPrimaryId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
      
    }
    else{
      
      data.testTrackPrimaryId = ''
      data.testTrackPrimaryName = ''
      timeSlots.primarySlotId = ''
      timeSlots.primaryStart = ''
      timeSlots.primaryStartM = ''
      timeSlots.primaryEnd = ''
      timeSlots.primaryEndM = ''
      timeSlots.primarySlots = []

      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.PrimaryFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})

      if(this.state.data.testTrackPrimaryId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots: timeSlots})
  }

  handleTestTrackOptionFirstChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackOptionFirstId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionFirstName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackOptionFirstId, 0, 2)
      this.computeFeeToBePaid(data.testTrackOptionFirstId, 2)  
      if(this.state.data.testTrackOptionFirstId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
    }
    else{
      data.testTrackOptionFirstId = ''
      data.testTrackOptionFirstName = ''
      timeSlots.optionFirstSlotId = ''
      timeSlots.optionFirstStart = ''
      timeSlots.optionFirstStartM = ''
      timeSlots.optionFirstEnd = ''
      timeSlots.optionFirstEndM = ''
      timeSlots.optionFirstSlots = []
      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.optionFirstFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})
      
      if(this.state.data.testTrackOptionFirstId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots: timeSlots})
  }

   handleTestTrackOptionSecondChange = (event) =>{
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
    if(event.target.value){
      data.testTrackOptionSecondId = event.target.value
      var optionElement = event.target.childNodes[event.target.selectedIndex]
      data.testTrackOptionSecondName = optionElement.getAttribute('data-name')
      this.getTimeSlotForTrack(data.testTrackOptionSecondId, 0, 3)
      this.computeFeeToBePaid(data.testTrackOptionSecondId, 3) 
      if(this.state.data.testTrackOptionSecondId ===''){
        data.noOfSelectedTrack = data.noOfSelectedTrack + 1
        
      }
    }
    else{
      data.testTrackOptionSecondId = ''
      data.testTrackOptionSecondName = ''
      timeSlots.optionSecondSlotId = ''
      timeSlots.optionSecondStart = ''
      timeSlots.optionSecondStartdM = ''
      timeSlots.optionSecondEnd = ''
      timeSlots.optionSecondEndM = ''
      timeSlots.optionSecondSlots = []
      let trackFee = Object.assign({}, this.state.trackFee)
      trackFee.optionSecondFee =0
      trackFee.feeToBePaid = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
      this.setState({trackFee: trackFee})

      if(this.state.data.testTrackOptionSecondId !==''){
        data.noOfSelectedTrack = data.noOfSelectedTrack - 1
        
      }
    }
    this.setState({data: data, timeSlots:timeSlots})
  }

  handleTestCenterChange =(event) =>{
    
    let data = Object.assign({}, this.state.data)
    let timeSlots = Object.assign({}, this.state.timeSlots)
      if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      
      
      data.testcenterId = selectedOption
      data.testCenterName = optionElement.getAttribute('data-name')
      data.testCenterCountryId = optionElement.getAttribute('date-countryid')
      //this.setState({data: data})

      data.testLocationOne = ''
      data.testLocationTwo = ''
      if(data.testCenterCountryId !== this.state.data.testCenterCountryId){
      	
        api.getTPOTestTracks(this.props.user.accessToken, data.testCenterCountryId)
          .then((testTrackPrimaryList) => {
            data.testTrackPrimaryList = testTrackPrimaryList
            data.testTrackPrimaryId = ''
            data.testTrackPrimaryName = ''
            data.testTrackOptionFirstList = testTrackPrimaryList
            data.testTrackOptionFirstId = ''
            data.testTrackOptionFirstName = ''
            data.testTrackOptionSecondList = testTrackPrimaryList
            data.testTrackOptionSecondId = ''
            data.testTrackOptionSecondName = ''
            data.noOfSelectedTrack = 0
            data.paymentModeId =''

            
            timeSlots.primarySlotId = ''
      			timeSlots.primaryStart = ''
      			timeSlots.primaryStartM = ''
      			timeSlots.primaryEnd = ''
      			timeSlots.primaryEndM = ''
      			timeSlots.primarySlots = []
            timeSlots.optionFirstSlotId = ''
      			timeSlots.optionFirstStart = ''
      			timeSlots.optionFirstStartM = ''
      			timeSlots.optionFirstEnd = ''
      			timeSlots.optionFirstEndM = ''
      			timeSlots.optionFirstSlots = []
      			timeSlots.optionSecondSlotId = ''
      			timeSlots.optionSecondStart = ''
      			timeSlots.optionSecondStartdM = ''
      			timeSlots.optionSecondEnd = ''
      			timeSlots.optionSecondEndM = ''
      			timeSlots.optionSecondSlots = []

            //this.setState({data: data})
            return api.getTPOCountryFee(this.props.user.accessToken, data.testCenterCountryId)  
          }).then((result) =>{
              data.countryFee = result
              return api.getTPOLocation(this.props.user.accessToken, data.testcenterId)          
        }).then((result) =>{
              data.testLocations = result
              data.testLocationOne =''
              data.testLocationTwo =''
              this.setState({data: data, timeSlots:timeSlots})
                        
        })

        let trackFee = Object.assign({}, this.state.trackFee)
        trackFee.PrimaryFee =0
        trackFee.optionFirstFee =0
        trackFee.optionSecondFee =0
        trackFee.feeToBePaid = 0
        this.setState({trackFee: trackFee})
         
      }
      else{
      	
        api.getTPOLocation(this.props.user.accessToken, data.testcenterId)          
        .then((result) =>{
              data.testLocations = result
              data.testLocationOne =''
              data.testLocationTwo =''
              this.setState({data: data})          
        })
      }
    }
    else{
       data.testcenterId = ''
       data.testCenterName = ''
       data.testLocationOne =''
       data.testLocationTwo =''
       data.testLocations =[]
       data.testCenterCountryId = ''
       data.testTrackPrimaryList = []
       data.testTrackPrimaryId = ''
       data.testTrackPrimaryName = ''
       data.testTrackOptionFirstList = []
       data.testTrackOptionFirstId = ''
       data.testTrackOptionFirstName = ''
       data.testTrackOptionSecondList = []
       data.testTrackOptionSecondId = ''
       data.testTrackOptionSecondName = ''
        let trackFee = Object.assign({}, this.state.trackFee)
        trackFee.PrimaryFee =0
        trackFee.optionFirstFee =0
        trackFee.optionSecondFee =0
        trackFee.feeToBePaid = 0
       let key = Object.keys(timeSlots)
       for (key in timeSlots) {
         if (timeSlots.hasOwnProperty(key)) {
          if(timeSlots[key] instanceof Array)
            timeSlots[key] =[]
          else
            timeSlots[key] =''
         }
        }
       this.setState({data: data, timeSlots:timeSlots, trackFee:trackFee})
    }


      
  }

  onInputChange = evt => {
    const data = Object.assign({}, this.state.data);
    data[evt.target.name] = evt.target.value;
    this.setState({data});
  }


  handleDiscountApply = (e) => {
    e.preventDefault()
    let data = Object.assign({}, this.state.data)
    let trackFee = Object.assign({}, this.state.trackFee)
    let formErrors = Object.assign({}, this.state.formErrors)
    let totalFee = parseFloat(trackFee.PrimaryFee) + parseFloat(trackFee.optionFirstFee) + parseFloat(trackFee.optionSecondFee)
    api.getTPODiscountPerTrack(this.props.user.accessToken,3, this.state.data.referralCode, totalFee, data.certification_participation_id)
      .then((result) => {
        
        if(result.status === 'success'){
          data.discountValuePerTrack =  Number(result.discount)
          formErrors.discountCodeError = ''
        }
        else{
          data.discountValuePerTrack = 0 
          formErrors.discountCodeError = result.message
        }
        trackFee.feeToBePaid = totalFee - data.discountValuePerTrack
        this.setState({data: data, trackFee: trackFee,  formErrors: formErrors})
    })
  }


  handleTeachingAssociationSelection = (event) =>{
    
    let data = Object.assign({}, this.state.data)
      
    if(event.target.value){
      let selectedOption = event.target.value
      var index = event.target.selectedIndex;
      var optionElement = event.target.childNodes[index]
      data.teachingAssociationId = parseInt(selectedOption)
      data.teachingAssociationName = optionElement.getAttribute('data-name')
    }
    else{
      data.teachingAssociationId = ''
      data.teachingAssociationName = ''
      
    }

    //console.log(data.teachingAssociationId)
    //console.log(data.teachingAssociationName)
    this.setState({data: data})

  }

  handleSchoolChange = (value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }

  handleSchoolSelect = (value) => {
    let data = Object.assign({}, this.state.data)
    data.workingOrganization = value
    this.setState({data: data})
  }
  
  validateForm(){

      let error = true
      let errorObj = Object.assign({}, this.state.formErrors)
      let data = Object.assign({}, this.state.data)
      let timeSlots = Object.assign({}, this.state.timeSlots)

      errorObj.testCenterError = ''
      errorObj.testTrackPrimaryIdError =''
      errorObj.primarySlotIdError =''
      errorObj.optionFirstSlotIdError =''
      errorObj.optionSecondSlotIdError =''
      errorObj.paymentModeError = ''
      errorObj.optionThirdWithoutSecondError = ''
      errorObj.firstNameError = ''
      errorObj.lastNameError = ''
      errorObj.emailError = ''
      errorObj.workingOrganizationError = ''
      errorObj.teachingAssociationIdError =''
      
      if(data.testcenterId === ''){
        errorObj.testCenterError = 'Test Center is mandatory'
        error = false
      }

      if(data.testTrackPrimaryId === ''){
        errorObj.testTrackPrimaryIdError = 'Test Track Primary is mandatory'
        error = false
      }

      if(timeSlots.primarySlotId === ''){
        errorObj.primarySlotIdError = 'Time Slot for Primary Track is mandatory'
        error = false
      }

      if(data.testTrackOptionFirstId !=='' && timeSlots.optionFirstSlotId === ''){
        errorObj.optionFirstSlotIdError = 'Time Slot for chosen track is mandatory'
        error = false
      }

      if(data.testTrackOptionSecondId !=='' && timeSlots.optionSecondSlotId === ''){
        errorObj.optionSecondSlotIdError = 'Time Slot for chosen track is mandatory'
        error = false
      }

      if(data.testTrackOptionFirstId === '' && data.testTrackOptionSecondId !==''){
        errorObj.optionThirdWithoutSecondError = 'Before selecting third track please select second track'
        error = false
      }

      if(data.paymentModeId === ''){
        errorObj.paymentModeError = 'Payment is mandatory'
        error = false
      }


      if(data.firstName === undefined || data.firstName === null || data.firstName === ''){
        errorObj.firstNameError = 'First Name is mandatory'
        error = false
      }

      if(data.lastName === undefined || data.lastName === null || data.lastName === ''){
        errorObj.lastNameError = 'Last Name is mandatory'
        error = false
      }

      
      if(data.email === null || data.email === ''){
        errorObj.emailError = 'Email is mandatory'
        error = false
      }
      else{
        var pattern = /^[a-zA-Z0-9\-_]+(\.[a-zA-Z0-9\-_]+)*@[a-z0-9]+(\-[a-z0-9]+)*(\.[a-z0-9]+(\-[a-z0-9]+)*)*\.[a-z]{2,4}$/;
        if(!pattern.test(this.state.data.email)){
          errorObj.emailError = 'Invalid Email Format. Please check'
          this.setState({formErrors: errorObj})
          error = false
        }
      }


      if(data.teachingAssociationId === ''){
        errorObj.teachingAssociationIdError ='Occupation is mandatory'
        error = false
      }

      if(data.teachingAssociationId && !(this.state.data.teachingAssociationId === 9 ||  this.state.data.teachingAssociationId === 10 || this.state.data.teachingAssociationId === 8)){
        if(data.workingOrganization  === ''){
          errorObj.workingOrganizationError ='Please enter the name of School/Organization/Institute'
          error = false
        }
      }

      let saveState = Object.assign({}, this.state.saveState)
      if(!error){        
        saveState.saveDisabled = false
      }
      else{
        saveState.saveDisabled = true
      }

      this.setState({
        formErrors:errorObj,
        errorMsg:'',
        saveState: saveState
      })
      return error
    }


  handleSubmit =(e) => {
    e.preventDefault()
    this.processRegistration(false)
  }

  processRegistration = (isPayment) => {
    
      let data = Object.assign({}, this.state.data)
      let timeSlots = Object.assign({}, this.state.timeSlots)
      if(this.validateForm()){
      //values start
      let apiInput = {
       'cert_part_id': data.certification_participation_id,
        'tpo_certification': {
           'test_center_id': data.testcenterId,
           'test_location_pref_one': data.testLocationOne,
           'test_location_pref_two': data.testLocationTwo,
           'working_organization': data.workingOrganization,
           'teaching_association_id': data.teachingAssociationId,
           'referral_code': data.referralCode,
         },      
        
        'payment': {
          'currency': data.countryFee.currency_name,
          'payment_mode_id': data.paymentModeId,
        },

        'tpo_certification_detail': {
          'test_track_primary': data.testTrackPrimaryId,
          'test_track_first_option': data.testTrackOptionFirstId,
          'test_track_second_option': data.testTrackOptionSecondId,
          'time_slot_primary': timeSlots.primarySlotId,
          'time_slot_first_option': timeSlots.optionFirstSlotId,
          'time_slot_second_option': timeSlots.optionSecondSlotId,

        },
        
        'user':{
          'email': data.email,
        },
        'personal_info':{
          'first_name': data.firstName,
          'last_name': data.lastName,
        },
        
        'payment_option':{
          'is_payment': isPayment
        }
      }
      // values end
      api.updateTPoRegistration(this.props.user.accessToken,apiInput)
      .then((result) => {
             
        if(result.errors){
          let saveState = Object.assign({}, this.state.saveState)
          saveState.saveDisabled = false
          this.setState({ errorMsg: result.errors, saveState: saveState })
        }
        else{
          
          this.setState({ updateMessage: result.message })
          //if(result.redirect_to)
          //window.location.href = result.redirect_to;
          //else
          //  this.props.history.push("/portal/app/my_registrations")
        }
      })
      .catch((err) => {
        this.setState({ errorMsg: err.stack })
      })

      }
      
    }


  handlePaymentModeChange = (event) => {
    let data = Object.assign({}, this.state.data)
    data.paymentModeId = event.target.value
    this.setState({data: data})
  }

  handleTestLocationOne = (event) =>{
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.testLocationOne = selectedOption   
      }
      else{
        data.testLocationOne =''
      }
      this.setState({data: data})
    }

    handleTestLocationTwo = (event) =>{
      let data = Object.assign({}, this.state.data)
      if(event.target.value){
        let selectedOption = event.target.value
        data.testLocationTwo = selectedOption   
      }
      else{
        data.testLocationTwo =''
      }
      this.setState({data: data})
    }

	render() {
		
		let trackPrimarySelected = this.state.data.testTrackPrimaryId
		let trackOptionFirstSelected = this.state.data.testTrackOptionFirstId
    let trackOptionSecondSelected = this.state.data.testTrackOptionSecondId

		let testTrackOptionPrimaryComponent = (
          <Select
            name="testTrackPrimary"
            onChange={this.handleTestTrackPrimaryChange}
            value={this.state.data.testTrackPrimaryId}
            
            placeholder="--- Select Test Track ---"
          >
            {this.state.data.testTrackPrimaryList.map(function(level){
              if(level.id === Number(trackOptionFirstSelected) ||
                  level.id === Number(trackOptionSecondSelected)){
                return (<option disabled key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                </option> )
              }
              else{
               return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                </option> )
              }
            })}
      </Select>
      
  	)

  	 let testTrackOptionFirstComponent = (
		      <Select
		        name="testTrackOptionFirst"
		        onChange={this.handleTestTrackOptionFirstChange}
		        value={this.state.data.testTrackOptionFirstId}
		        
		        placeholder="--- Select Optional Track ---"
		      >
		        {this.state.data.testTrackOptionFirstList.map(function(level){
		          if(level.id === Number(trackPrimarySelected) ||
		              level.id === Number(trackOptionSecondSelected)){
		            return (<option disabled key={level.id} value={level.id} data-name={level.name}>
		              {level.name}
		            </option> )
		          }
		          else{
		           return (<option key={level.id} value={level.id} data-name={level.name}>
		              {level.name}
		            </option> )
		          }
		        })}
		  </Select>
                  
    ) 
             

      let testTrackOptionSecondComponent
      testTrackOptionSecondComponent = (
              <Select
                name="testTrackOptionSecond"
                onChange={this.handleTestTrackOptionSecondChange}
                value={this.state.data.testTrackOptionSecondId}
                
                placeholder="--- Select Optional Track ---"
              >
                {this.state.data.testTrackOptionSecondList.map(function(level){
                  if(level.id === Number(trackPrimarySelected) ||
                      level.id === Number(trackOptionFirstSelected)){
                    return (<option disabled key={level.id} value={level.id} data-name={level.name}>
                      {level.name}
                    </option> )
                  }
                  else{
                   return (<option key={level.id} value={level.id} data-name={level.name}>
                      {level.name}
                    </option> )
                  }
                })}
          </Select>
        
      ) 


    //timeslot component - start
    
    let timeSlotDisplay
    let optionFirstTimeSlotComponent
    let optionSecondTimeSlotComponent
    let checkTimeOverlapFn = this.checkTimeOverlap

    let primaryTimeSlotComponent = (
                                      <Select
                        name="primaryTimeSlot"
                        onChange={this.handleTimeSlotChange}
                        value={this.state.timeSlots.primarySlotId}
                        className="tpo-track-slot-col"
                        placeholder="--- Select Time Slot ---"
                      >
                        {this.state.timeSlots.primarySlots.map(function(level){
                            timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                            if(checkTimeOverlapFn(1, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                              return (<option disabled key={level.id} value={level.id}
                                        option-sequence='1'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}
                                        >
                                {timeSlotDisplay}
                              </option> )
                            }
                            else{
                              return (<option key={level.id} value={level.id}
                                        option-sequence='1'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}
                                        >
                                {timeSlotDisplay}
                              </option> ) 
                            }
                        })}
                  </Select>
                  
              ) 
    
    optionFirstTimeSlotComponent = (
                                      <Select
                        name="optionFirstTimeSlot"
                        onChange={this.handleTimeSlotChange}
                        value={this.state.timeSlots.optionFirstSlotId}
                        className="tpo-track-slot-col"
                        placeholder="--- Select Time Slot ---"
                      >
                        {this.state.timeSlots.optionFirstSlots.map(function(level){
                            timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                            if(checkTimeOverlapFn(2, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                              return (<option disabled key={level.id} value={level.id}
                                        option-sequence='2'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                {timeSlotDisplay}
                              </option> )
                            }
                            else{
                              return (<option key={level.id} value={level.id}
                                      option-sequence='2'
                                      option-start={level.start_time} option-startm={level.start_time_meridiem}
                                      option-end={level.end_time} option-endm={level.end_time_meridiem}>
                              {timeSlotDisplay}
                            </option> )
                            }
                        })}
                  </Select>
                  
              ) 
    

    
      optionSecondTimeSlotComponent= (
                                      <Select
                        name="optionSecondTimeSlot"
                        onChange={this.handleTimeSlotChange}
                        value={this.state.timeSlots.optionSecondSlotId}
                        className="tpo-track-slot-col"
                        placeholder="--- Select Time Slot ---"
                      >
                        {this.state.timeSlots.optionSecondSlots.map(function(level){
                            timeSlotDisplay = Number(level.start_time).toFixed(2)+level.start_time_meridiem+' '+'to'+' '+Number(level.end_time).toFixed(2)+level.end_time_meridiem+' '+level.time_zone
                            if(checkTimeOverlapFn(3, level.start_time, level.start_time_meridiem, level.end_time, level.end_time_meridiem)){
                              return (<option disabled key={level.id} value={level.id}
                                        option-sequence='3'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                {timeSlotDisplay}
                              </option> )
                            }
                            else{
                              return (<option key={level.id} value={level.id}
                                        option-sequence='3'
                                        option-start={level.start_time} option-startm={level.start_time_meridiem}
                                        option-end={level.end_time} option-endm={level.end_time_meridiem}>
                                {timeSlotDisplay}
                              </option> ) 
                            }  
                        })}
                            
                  </Select>
                  
              ) 
        
        
    //timeslot component - end
    
    let feeToBePaidComponent
    if(this.state.data.countryFee.currency_name ==='RS' && this.state.trackFee.feeToBePaid){
      let regFee = this.state.trackFee.feeToBePaid
      let regFeeWithoutGST = regFee / 1.18
      feeToBePaidComponent = <h4> Total registration fee {this.state.data.countryFee.currency_name} {this.state.trackFee.feeToBePaid}{'/-'} (Rs.{parseFloat(regFeeWithoutGST).toFixed(2)} + 18% GST)</h4>
    }
    else{
     feeToBePaidComponent = <h4> Total registration fee {this.state.data.countryFee.currency_name} {this.state.trackFee.feeToBePaid}{'/-'}</h4>  
    }
    
    let testCityCountryId = this.state.data.testCenterCountryId
    let paymentModeComponent =(
                    <Select
                      name="payment_mode"
                      onChange={this.handlePaymentModeChange}
                      value={this.state.data.paymentModeId}
                      className="select-component"
                      placeholder="--Select Payment Mode--"
                    >
          {this.state.data.payment_modes.map(function(level){
            if(level.id !== 2){
              if((testCityCountryId === '1' && (level.id === 4 || level.id === 5 || level.id === 6 || level.id === 7)))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>)
              
              else if((testCityCountryId === '2' && level.id === 3))
                return (<option key={level.id} value={level.id} data-name={level.name}>
                  {level.name}
                  </option>) 
              }
            
                      })}
            </Select>
      )
      
    let TeachingOtherComponent = (
            <PlacesAutoComplete
          value={this.state.data.workingOrganization}
            onChange={this.handleSchoolSelect}
            onSelect={this.handleSchoolChange}
            >
            {({ getInputProps, suggestions, getSuggestionItemProps }) => (
            <div>
              <TextField
                {...getInputProps({
                  placeholder: 'School/Organization/Institute',
                  className: 'location-search-input'
                })}
                name="school"
                className="two-col-input"
              />
              <div className="autocomplete-dropdown-container">
                {suggestions.map(suggestion => {
                  const className = suggestion.active ? 'suggestion-item--active' : 'suggestion-item';
                  // inline style for demonstration purpose
                  const style = suggestion.active
                              ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                              : { backgroundColor: '#ffffff', cursor: 'pointer' };
                  return (
                    <div {...getSuggestionItemProps(suggestion, { className, style })}>
                      <span>{suggestion.description}</span>
                    </div>
                  )
                })}
              </div>
            </div>
          )}
        </PlacesAutoComplete>  
    )


    let contentToShow

    if(!  this.state.loading){
      contentToShow = (
          <div className="loader-component">
            <div className="loader"></div>
            <h4> Loading. Please wait..</h4>
          </div>
        )
    }
    else{
      contentToShow = (
        <Grid className="opportunity-list-item">
          <GridCell span="6">
          <TextField label="First Name" autoComplete="off" name="firstName" onChange={this.onInputChange} value={this.state.data.firstName}/>
          </GridCell>
          <GridCell span="6">
          <TextField label="Last Name" autoComplete="off" name="lastName" onChange={this.onInputChange} value={this.state.data.lastName}/>
          </GridCell>

          <GridCell span="6">
          <TextField label="email" autoComplete="off" name="email" onChange={this.onInputChange} value={this.state.data.email}/>
          </GridCell>

          <GridCell span="6">
              {TeachingOtherComponent}
          </GridCell>

          <GridCell span="4">
            <div className="full-width">
              <Select
                name="teachingAssociation"
                onChange={this.handleTeachingAssociationSelection}
                value={this.state.data.teachingAssociationId}
                className="two-col-input"
                placeholder="---Occupation---"
              >
                {this.state.data.teachingAssociations.map(level => (
                  <option key={level.id} value={level.id} data-name={level.name}>
                    {level.name}
                  </option>
                ))}
              </Select>
            </div>
          </GridCell>
          <GridCell span="8"/>
          
          <GridCell span="4">
            <div className="full-width">
              <Select
                    name="testcenter"
                    onChange={this.handleTestCenterChange}
                    value={this.state.data.testcenterId}
                    placeholder="--- Select Test City ---"
                  >
                    {this.state.data.testcenters.map(testcenter => (
                      <option key={testcenter.id} value={testcenter.id} data-name={testcenter.name}
                        date-countryid = {testcenter.country_id}>
                        {testcenter.name}
                      </option>
                    ))}
              </Select>
            </div>
          </GridCell>
          <GridCell span="4">

            {this.state.data.testLocations.length !=0 &&
              <div className="full-width"><Select
                    name="testlocationone"
                    onChange={this.handleTestLocationOne}
                    value={this.state.data.testLocationOne}
                    className="four-col-input tpo-reg-form-second-col"
                    placeholder="--Location Preference I --"
                  >
                    {this.state.data.testLocations.map(testlocation => (
                      <option key={testlocation.id} value={testlocation.name} data-name={testlocation.id}
                        locationpref = '1'>
                        {testlocation.name}
                      </option>
                    ))}
              </Select></div>
              }
            </GridCell>

            <GridCell span="4">
            {this.state.data.testLocations.length !=0 &&
             <div className="full-width"><Select
                  name="testlocationtwo"
                  onChange={this.handleTestLocationTwo}
                  value={this.state.data.testLocationTwo}
                  className="four-col-input tpo-reg-form-second-col"
                  placeholder="--Location Preference II --"
                >
                  {this.state.data.testLocations.map(testlocation => (
                    <option key={testlocation.id} value={testlocation.name} data-name={testlocation.id}
                      locationpref = '2'>
                      {testlocation.name}
                    </option>
                  ))}
            </Select></div>
            }
           </GridCell>

          <GridCell span="12">
            <Typography use="subtitle">Please select your test track and time slot. Please note that TPO 2020 offers subject tracks to choose from.</Typography>
          </GridCell>

          <GridCell span="6">{testTrackOptionPrimaryComponent}</GridCell>
          <GridCell span="6">{primaryTimeSlotComponent}</GridCell>
          <GridCell span="6">{testTrackOptionFirstComponent}</GridCell>
          <GridCell span="6">{optionFirstTimeSlotComponent}</GridCell>
          <GridCell span="6">{testTrackOptionSecondComponent}</GridCell>
          <GridCell span="6">{optionSecondTimeSlotComponent}</GridCell>

          <GridCell span="6"> {feeToBePaidComponent} </GridCell>
          <GridCell span="6"/>
          
          <GridCell span="5">
            <div className="hidden-div"> 
              <TextField label="Enter referral code (if any)" autoComplete="off" name="referralCode" onChange={this.onInputChange} value={this.state.data.referralCode}/>
              <Button onClick={this.handleDiscountApply}>Apply</Button>
              <StatusMessage error_msg = {this.state.formErrors.discountCodeError}/>
            </div>
          </GridCell>
          <GridCell span="7">
            
          </GridCell>
          

          <GridCell span="6"> {paymentModeComponent} </GridCell>
          <GridCell span="6"/>

          

          <GridCell span="5"/>
          <GridCell span="2"> <Button raised disabled={this.state.saveState.saveDisabled} onSubmit={this.handleSubmit}>Update</Button> </GridCell>
          <GridCell span="5"/>
        
          <GridCell span="10">
            <div className="success-style"> {this.state.updateMessage} </div>
            <StatusMessage error_msg = {this.state.errorMsg}/>
            <StatusMessage error_msg = {this.state.formErrors.testTrackPrimaryIdError}/>
            <StatusMessage error_msg = {this.state.formErrors.primarySlotIdError}/>
            <StatusMessage error_msg = {this.state.formErrors.testCenterError}/>
            <StatusMessage error_msg = {this.state.formErrors.optionFirstSlotIdError}/>
            <StatusMessage error_msg = {this.state.formErrors.optionSecondSlotIdError}/>
            <StatusMessage error_msg = {this.state.formErrors.paymentModeError}/>
            <StatusMessage error_msg = {this.state.formErrors.optionThirdWithoutSecondError}/>
            <StatusMessage error_msg = {this.state.formErrors.firstNameError}/>
            <StatusMessage error_msg = {this.state.formErrors.lastNameError}/>
            <StatusMessage error_msg = {this.state.formErrors.emailError}/>
            <StatusMessage error_msg = {this.state.formErrors.teachingAssociationIdError}/>
            <StatusMessage error_msg = {this.state.formErrors.workingOrganizationError}/>

          </GridCell>

        </Grid>

        )
    }

    
      
		return (
       <Grid>
        <GridCell span="12">
          <form onSubmit={this.handleSubmit} style={{width: '100%'}}>
            <Card style={{padding: '25px'}}>
              <Typography use="headline5">Update your TPO Registration details</Typography>

                {contentToShow}
              
            </Card>
          </form>
        </GridCell>
       </Grid>
      )

	}

}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(TPORegistrationUpdate);




// WEBPACK FOOTER //
// ./src/views/TPORegistrationUpdate.jsx